<template>
  <div>
    <b-sidebar
      id="add-bus-sidebar"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      :visible="addServiceSidebar"
      right
      no-header
      backdrop
      @hidden="(val) => changeValue(val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5
            class="mb-0"
          >
            Bayar Pajak
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Body -->
        <validation-observer
          ref="simpleRules"
          class="px-2"
        >
          <b-form>
            <b-row class="px-2">
              <b-col md="12">
                <b-form-group
                  label="Bukti Pembayaran"
                  label-for="foto-bukti-pembayaran"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Bukti Pembayaran"
                    rules="required"
                  >
                    <b-form-file
                      id="foto-bukti-pembayaran"
                      v-model="pajakLocal.bukti_pembayaran"
                      accept="image/*"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Pilih File"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Jatuh Tempo Selanjutnya"
                  label-for="jatuh_tempo_selanjutnya"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Jatuh Tempo Selanjutnya"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="jatuh_tempo_selanjutnya"
                      v-model="pajakLocal.jatuh_tempo"
                      :state="errors.length > 0 ? false:null"
                      class="mb-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Biaya Selanjutnya"
                  label-for="biaya"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Biaya Selanjutnya"
                    rules="required"
                  >
                    <b-form-input
                      id="biaya"
                      v-model="pajakLocal.jumlah"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Biaya Selanjutnya"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="submit()"
                >
                  Submit
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="changeValue(false)"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BButton, BCol,
  BRow, BSidebar, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { integer } from 'vee-validate/dist/rules'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BCol,
    BRow,
    BSidebar,
    BFormDatepicker,
    BFormFile,
  },
  model: {
    prop: 'addServiceSidebar',
  },
  props: {
    addServiceSidebar: {
      type: Boolean,
      required: true,
    },
    pajak: {
      type: integer,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      pajakLocal: {
        id: null,
        jatuh_tempo: null,
        jumlah: null,
        bukti_pembayaran: null,
      },
      options: [
        { value: 'belum_dibayar', text: 'Belum Dibayar' },
        { value: 'sudah_dibayar', text: 'Sudah Dibayar' },
      ],
    }
  },
  watch: {
    pajak() {
      this.resetTaskLocal()
    },
  },
  methods: {
    resetTaskLocal() {
      this.pajakLocal = {
        id: this.pajak,
        jatuh_tempo: null,
        jumlah: null,
        bukti_pembayaran: null,
      }
    },
    changeValue() {
      const data = {
        id: null,
        jatuh_tempo: null,
        jumlah: null,
        bukti_pembayaran: null,
      }
      this.$emit('pajak-sidebar-change', data, false)
    },
    submit() {
      this.$emit('submit-bayar-pajak', this.pajakLocal)
    },
  },
}
</script>
<style>
.b-sidebar-body {
  overflow: hidden !important;
}
</style>
